import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";
import { PageHero, EnquiryBanner } from "@/components/site/Sections";
import { Printer, BookOpen, Package, PenTool, Megaphone, Building2, Store } from "lucide-react";
import { INDUSTRIES } from "@/lib/data";

const ICONS = [Printer, BookOpen, Package, PenTool, Megaphone, Building2, Store];

const Industries = () => (
  <div data-testid="industries-page">
    <PageHero
      label="Industries Served"
      title="Paper for every corner of print & packaging."
      subtitle="We understand the demands of each industry we serve — and we source the right grades to match."
    />

    <section className="relative z-10 pb-24 lg:pb-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Stagger className="grid gap-px bg-paper-border border border-paper-border rounded-sm overflow-hidden md:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <StaggerItem key={ind.name} className="group bg-paper p-9 lg:p-11 transition-colors duration-300 hover:bg-forest">
                <Icon className="h-9 w-9 text-forest transition-colors duration-300 group-hover:text-paper" strokeWidth={1.5} />
                <h2 className="mt-6 font-serif text-3xl text-forest transition-colors duration-300 group-hover:text-paper">{ind.name}</h2>
                <p className="mt-4 text-sm text-ink-soft leading-relaxed transition-colors duration-300 group-hover:text-paper/70">{ind.body}</p>
              </StaggerItem>
            );
          })}
        </Stagger>

        <Reveal className="mt-16">
          <div className="overflow-hidden rounded-sm">
            <img
              src="https://images.unsplash.com/photo-1503694978374-8a2fa686963a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBwcmludGluZyUyMHByZXNzfGVufDB8fHx8MTc4NDAzOTQ2NXww&ixlib=rb-4.1.0&q=85"
              alt="Commercial printing press at work"
              className="w-full h-[300px] lg:h-[460px] object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>

    <EnquiryBanner />
  </div>
);

export default Industries;
